import React from "react";
import { Box, Typography } from "@mui/material";
import { COULEUR_DOMAINE, Domaine } from "../../theme/tribeTheme";
import { CarreDomaine } from "./Bloc";
import BoutonAide from "./BoutonAide";

/* En-tête d'une page : carré de couleur du domaine, titre Montserrat,
   une phrase, aide facultative, actions à droite. */
export default function EnTetePage({ domaine, titre, phrase, aide, actions }: {
  domaine: Domaine; titre: string; phrase?: string; aide?: string; actions?: React.ReactNode;
}) {
  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 3, flexWrap: "wrap" }}>
      <Box sx={{ flex: 1, minWidth: 240 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          <CarreDomaine couleur={COULEUR_DOMAINE[domaine]} taille={12} />
          <Typography component="h1" sx={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: { xs: 22, md: 26 }, lineHeight: 1.2, color: "var(--c-text-primary)" }}>
            {titre}
          </Typography>
          {aide && <BoutonAide texte={aide} />}
        </Box>
        {phrase && (
          <Typography sx={{ mt: 0.75, fontSize: 14.5, color: "var(--c-text-secondary)", maxWidth: 760 }}>{phrase}</Typography>
        )}
      </Box>
      {actions && <Box sx={{ display: "flex", gap: 1.25, alignItems: "center", flexWrap: "wrap" }}>{actions}</Box>}
    </Box>
  );
}
